import React from 'react';
import cx from 'classnames';
import { withStyles, createStyles, WithStyles, Theme } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';

interface Props {
  isFixed?: boolean;
}

const styles = (t: Theme) =>
  createStyles({
    progress: {
      // app bar: 1100
      zIndex: 1105,
      position: 'absolute',
      left: 0,
      top: 0,
      right: 0,
      bottom: 0,
      background: 'rgba(235, 235, 235, 0.7)',
      transition: 'opacity 0.2s ease-in',
      display: 'flex',
      verticalAlign: 'middle',
      alignItems: 'center',
      justifyContent: 'center',
    },
    fixed: {
      position: 'fixed',
    },
  });

const Loader: React.FC<Props & WithStyles<typeof styles>> = ({
  classes,
  isFixed,
}) => (
  <div
    data-test-locator="Loader"
    className={cx(classes.progress, { [classes.fixed]: isFixed })}
  >
    <CircularProgress size={50} color="primary" />
  </div>
);

export default withStyles(styles)(Loader);
